import { EventEmitter, signal } from '@angular/core';

export interface DrawerPanel {
  id: string;
  icon: string;
  title: string;
  description?: string;
}

export enum DrawerModes {
  OVER = 'over',
  SIDE = 'side',
}

export abstract class BaseDrawerAuraComponent {
  public abstract title: string;
  public abstract drawerMode: DrawerModes;
  public abstract drawerOpened: boolean;
  public abstract panels: DrawerPanel[];

  selectedPanel = signal<DrawerPanel | null>(null);
  isLoading = true;
  loading = new EventEmitter<boolean>();

  onPanelChanged(panel: DrawerPanel) {
    this.selectedPanel.set(panel);
  }
}
